<template>
  <div>
    <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" ref="form" :model="form">
      <a-form-model-item label="客户名称" prop="name">
        <a-input v-model="form.data.name" auto-complete="off" placeholder="请输入客户名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="客户号" prop="number">
        <a-input v-model="form.data.number" auto-complete="off" placeholder="请输入客户号"></a-input>
      </a-form-model-item>
    </a-form-model>
<!--    <div slot="footer" class="dialog-footer" style="text-align: center;">-->
<!--      <a-button type="primary" v-if="!bizCompanyId" @click="onAdd">创建</a-button>-->
<!--      <a-button type="primary" v-if="bizCompanyId" @click="onUpdate">更新</a-button>-->
<!--      <a-button @click="onCancel">取消</a-button>-->
<!--    </div>-->
  </div>
</template>

<script>
import {
  _queryBizCompany,
  _addBizCompany,
  _updateBizCompany,
} from '../../../api/bizCompanyApi';

async function getBizCompany() {
  if (this.bizCompanyId) {
    const result = await _queryBizCompany(this.bizCompanyId);
    if (result.code === 1200) {
      this.form.data.createAt = result.data.bizCompany.createAt;
      this.form.data.updateAt = result.data.bizCompany.updateAt;
      this.form.data.createUserId = result.data.bizCompany.createUserId;
      this.form.data.updateUserId = result.data.bizCompany.updateUserId;
      this.form.data.name = result.data.bizCompany.name;
      this.form.data.number = result.data.bizCompany.number;
    }
  }
}

async function onAdd() {
  const result = await _addBizCompany({
    createUserId: this.form.data.createUserId,
    updateUserId: this.form.data.updateUserId,
    name: this.form.data.name,
    number: this.form.data.number,
  });
  if (result.code === 1200) {
    this.$message.success('添加成功')
    this.getBizCompanyList()
    // if (this.onSubmitHandler) {
    //   this.$message({
    //     message: '添加成功',
    //     type: 'success',
    //   });
    //   this.onSubmitHandler();
    // }
  }
}

async function onUpdate() {
  const result = await _updateBizCompany(this.bizCompanyId, {
    id: this.form.data.id,
    createUserId: this.form.data.createUserId,
    updateUserId: this.form.data.updateUserId,
    name: this.form.data.name,
    number: this.form.data.number,
  });
  if (result.code === 1200) {
    // if (this.onSubmitHandler) {
    //   this.$message({
    //     message: '更新成功',
    //     type: 'success',
    //   });
    //   this.onSubmitHandler();
    // }
    this.$message.success('更新成功')
    this.getBizCompanyList()
  }
}

function onCancel() {
  // if (this.onCancelHandler) {
  //   this.onCancelHandler();
  // }
}

export default {
  name: 'BizCompanyEdit',
  props: {
    bizCompanyId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
    getBizCompanyList: Function
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getBizCompany,
    submit(){
      if (this.bizCompanyId&&this.bizCompanyId.trim()!==''){
        this.onUpdate();
      }else {
        this.onAdd();
      }
    }
  },
  data() {
    return {
      form: {
        data: {
          id: '',
          createAt: '',
          updateAt: '',
          createUserId: '',
          updateUserId: '',
          name: '',
          number: '',
        },
        title: '',
      },
    };
  },
  created() {
    this.form.data.id = this.bizCompanyId;
      this.getBizCompany();
  },
};
</script>
